export default "__VITE_ASSET__f3884963__"